import React, { Component } from 'react'
import uuid from 'uuid'
import SectionStructure from '../../../structures/section/index'

class Section extends Component {
  constructor(props) {
    super(props)
    this.id = props.id
    this.type = 'section'
  }

  static defaultProps = {
    id: uuid.v4(),
    header: {
      title: {
        content: ''
      }
    },
    list: [],
    footer: {}
  };

  render() {
    const structure = new SectionStructure(this.props)
    return structure.current().html
  }
}

export default Section


// WEBPACK FOOTER //
// ./app/javascript/app/site/components/site_layout/section/index.js